<template>
  <h1 class="page-heading" v-bind="$attrs"><slot></slot></h1>
</template>
<script>
export default {
  name: "M4PageHeading",
  props: {}
};
</script>
